// @flow strict

import * as React from 'react';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
// import type { LightVariants } from '../../internal/Button';
import { Link } from '../../internal/Button';
import PageContentBlock from '../../internal/PageContentBlock';
import type { Layout } from '../../internal/types';

type PropTypes = {|
  background: 'Dark' | 'Citrus' | 'White' | 'Charcoal' | 'Silver' | 'Black',
  // buttonVariant?: LightVariants,
  href: string,
  children: string,
  position: 'Left' | 'Right' | 'Center',
  layout?: Layout,
|};

const backgroundMap = {
  Dark: 'Dark',
  Black: 'Dark',
  Citrus: 'Featured',
  White: 'White',
  Charcoal: 'Charcoal',
  Silver: 'Silver',
};

const buttonVarinatMap = {
  Dark: 'White',
  Black: 'Citrus',
  Citrus: 'Transparent',
  White: 'Transparent',
  Charcoal: 'Transparent',
  Silver: 'Transparent',
};

const ButtonCta = (props: PropTypes) => {
  return (
    <PageContentBlock layout={props.layout} background={backgroundMap[props.background]}>
      <div className={styles[`is${props.position}`]}>
        <Link variant={buttonVarinatMap[props.background]} href={props.href}>
          {props.children}
        </Link>
      </div>
    </PageContentBlock>
  );
};

ButtonCta.defaultProps = {
  position: 'Left',
  background: 'Black',
};

// This is repo check commit - cleanup later

export default ButtonCta;
